import { useEffect, useState } from "react";
import axios from "axios";
import "./page.css";

const API_URL = "https://irc.zentelex.com/api/pest-control/pest-controls";

const PestControlList = ({ reload }) => {
  const [pests, setPests] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filters
  const [companyFilter, setCompanyFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    fetchPestControls();
  }, [reload]);

  const fetchPestControls = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(API_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPests(res.data.data);
    } catch (error) {
      console.error("Failed to fetch pest controls", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter pests before rendering
  const filteredPests = pests.filter((pest) => {
    const matchesCompany = companyFilter
      ? pest.companyName.toLowerCase().includes(companyFilter.toLowerCase())
      : true;

    const matchesFromDate = fromDate
      ? new Date(pest.lastPestControlDate) >= new Date(fromDate)
      : true;

    const matchesToDate = toDate
      ? new Date(pest.lastPestControlDate) <= new Date(toDate)
      : true;

    return matchesCompany && matchesFromDate && matchesToDate;
  });

  if (loading) return <div className="loader">Loading pest controls...</div>;

  return (
    <div className="admin-container">
      <h2 className="page-title">Pest Control Records</h2>

      {/* Filters */}
      <div className="filters">
        <input
          type="text"
          placeholder="Filter by company"
          className="filter-input"
          value={companyFilter}
          onChange={(e) => setCompanyFilter(e.target.value)}
        />

        <input
          type="date"
          className="filter-input"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />

        <input
          type="date"
          className="filter-input"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />

        <button
          className="clear-filters"
          onClick={() => {
            setCompanyFilter("");
            setFromDate("");
            setToDate("");
          }}
        >
          Clear
        </button>
      </div>

      <div className="table-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Serial No</th>
              <th>Company</th>
              <th>Last Pest Control</th>
              <th>Next Pest Control</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {filteredPests.map((pest, index) => (
              <tr key={pest.id}>
                <td>{index + 1}</td>
                <td>{pest.serialNo}</td>
                <td>{pest.companyName}</td>
                <td>
                  {new Date(pest.lastPestControlDate).toLocaleDateString(
                    "en-IN",
                  )}
                </td>
                <td>
                  {pest.nextPestControlDate
                    ? new Date(pest.nextPestControlDate).toLocaleDateString(
                        "en-IN",
                      )
                    : "-"}
                </td>
                <td>{pest.remarks || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {filteredPests.length === 0 && (
          <div className="empty-state">No pest control records found</div>
        )}
      </div>
    </div>
  );
};

export default PestControlList;
